import Button from '../Button';

interface DeleteConfirmationOverlayProps {
  onClose: () => void;
  onDelete?: () => void;
}

export default function DeleteConfirmationOverlay({ onClose, onDelete }: DeleteConfirmationOverlayProps) {
  return (
    <div
      id="file-editor"
      className="absolute left-1/2 top-1/2 flex min-h-[6.625rem] min-w-[20rem] max-w-md -translate-x-1/2 -translate-y-1/2 flex-col rounded-xl border border-gray-300 bg-white p-6 shadow-lg md:min-w-[29rem]"
    >
      <div className="content flex flex-col gap-4">
        <div className="head flex flex-col gap-2">
          <h5 className="text-xl font-semibold text-gray-900">Delete Item</h5>
          <p className="body-md text-gray-600">Are you sure you want to delete this item?</p>
        </div>
        <div className="actions flex w-full items-center justify-end gap-3">
          <Button
            variant="secondary"
            onClick={() => {
              onClose();
            }}
            className="rounded-lg px-4 py-2 text-gray-700 hover:bg-gray-100"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="flex items-center gap-2 rounded-lg bg-[#039BE5] px-4 py-2 hover:bg-[#0288D1]"
            onClick={() => {
              if (onDelete) onDelete();
              onClose();
            }}
          >
            <svg 
              width="18" 
              height="18" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className="text-white"
            >
              <path 
                d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z" 
                fill="currentColor"
              />
            </svg>
            <p className="button font-medium">Delete</p>
          </Button>
        </div>
      </div>
    </div>
  );
}
